import styled from 'styled-components'

export const Container = styled.section`
  grid-area: ${({ $kind }) => ($kind === 'practice' ? 'practice' : 'projects')};
  margin-inline-end: 1rem;
  margin-inline-start: 1rem;
  margin-top: 2rem;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`

export const Intro = styled.p`
  margin: 0.75rem 0 0;
  // max-width: 680px;
  font-size: 1rem;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const EmptyState = styled.p`
  margin-top: 2rem;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const ErrorState = styled.p`
  margin-top: 2rem;
  color: ${({ theme }) => theme.colors.textMuted};
`
